// Component here uses ES6 destructuring syntax in import, what is means is 'retrieve the property 'Component' off of the object exported from the 'react'
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { stringify as queryStringify } from 'querystring';
import SearchIcon from '../../../common/svgs/SearchIcon';

// helper functions
import _ from 'lodash';

@connect(store => {
  const searchQuery = store.routing.locationBeforeTransitions.query.search;
  const search = searchQuery && [].concat(searchQuery) || [];
  return { search };
})
export default class Search extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object,
    search: PropTypes.array,
    onTermChange: PropTypes.func,
    defaultValues: PropTypes.array,
    baseUrl: PropTypes.string,
    placeHolder: PropTypes.string
  }

  static defaultProps = {
    placeHolder: 'Search...'
  }

  constructor(props, context) {
    super(props, context);

    // asyncActionCreator.search(this.state.searchTags.concat(str))
    // only run search when there's 50 ms of no other running's of search
    this.search = (arr = []) => { // default to empty array
      this.props.dispatch(push(`${this.props.baseUrl}/${arr.length ? `?${queryStringify({search: arr})}` : ''}`));
      this.props.onTermChange(arr);
    };
    this.debouncedSearch = _.debounce(this.search, 200);
  }

  state = {
    searchTags:[]
  }

  componentWillMount() {
    const terms = _.isEmpty(this.props.search) ? (this.props.defaultValues === undefined ? [] : this.props.defaultValues) : this.props.search;
    this.setState(
      () => ({searchTags: terms}),
      () => {
        this.debouncedSearch(terms);
      }
    );
  }

  inputKeyEvents(e) {
    if (e.key === 'Enter' || e.key === ' ') { // Enter pressed
      if (e.target.value.trim()) { // test if input is empty

        const targetValue = e.target.value.trim();
        this.setState(prevState => {
          const updatedSearch = prevState.searchTags.concat(targetValue);
          this.search(updatedSearch);
          return { // add tag
            searchTags: updatedSearch// remove whitespace at the beginning and end of string
          };
        }, () => {
          this.refs.search.value = '';
        });

      }
    }
    if (!e.target.value && this.state.searchTags.length && e.key === 'Backspace') { // Backspace pressed
      this.removeTag(this.state.searchTags.length-1);
    }
  }

  removeTag(removalIndex) {

    this.setState(prevState => {
      const updatedSearch = prevState.searchTags.filter((val, index) => index !== removalIndex);
      this.debouncedSearch(updatedSearch);
      return {
        searchTags: updatedSearch
      };
    });

  }

  searchOnChange(e) {
    if (e.target.value.trim().length > 2 || e.key === 'Backspace') {
      this.debouncedSearch(this.state.searchTags.concat(e.target.value.trim()));
    }
  }

  render() {
    return (
      <div className='search'>

        <div className='search-input-container'>
          <SearchIcon />
          {
            this.state.searchTags.map((val, index) =>
              <div className='search-tag' key={index}>
                {val}
                <span className='close-icon' onClick={this.removeTag.bind(this, index)}/>
              </div>
            )
          }
          <input data-id='Search'
                 ref='search'
                 className='search-input'
                 type='text'
                 placeholder={this.props.placeHolder}
                 onKeyDown={::this.inputKeyEvents}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/Search/index.js